import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/pricelist-seasons', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/pricelist-seasons/${id}`, data)
    .then(response => response.data)
}

export default {
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  fetch(params) {
    return axios.get('/pricelist-seasons', { params: params })
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/pricelist-seasons/${id}`)
  }
}
